import { render, staticRenderFns } from "./update-phone.vue?vue&type=template&id=00195264&"
import script from "./update-phone.vue?vue&type=script&lang=js&"
export * from "./update-phone.vue?vue&type=script&lang=js&"
import style0 from "./update-phone.vue?vue&type=style&index=0&id=00195264&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports